<template>
    <q-dialog v-model="modal" transition-show="scale" transition-hide="scale" :maximized="$q.platform.is.mobile">
        <q-card v-if="address" class="modal-new-address">
            <div class="modal-header">
                <span class="modal-title">Добавление адреса</span>
                <div class="modal-close" @click="modal=false">
                    <span aria-hidden="true">
                        <svg version="1.1" id="" xmlns="http://www.w3.org/2000/svg" xmlns:xli.nav-itemnk="http://www.w3.org/1999/xli.nav-itemnk" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
            </div>

            <q-card-section class="modal-content">

                <div class="d-flex mb-3">
                    <span class="link" @click.prevent="useRegion = true" v-if="!useRegion">Моего города нет в списке</span>
                </div>
                <q-select
                    v-if="useRegion"
                    clearable
                    square
                    outlined
                    hide-selected
                    fill-input
                    use-input
                    input-debounce="0"
                    :value="address.region.id"
                    @input="setRegion"
                    option-value="id"
                    option-name="label"
                    :options="regionOptions"
                    :options-dense="true"
                    @filter="searchRegion"
                    emit-value
                    map-options
                    behavior="menu"
                    :error-message="address.errors.get('region.name')"
                    :error="address.errors.has('region.name')"
                    label="Регион">
                </q-select>
                <q-select
                    clearable
                    square
                    outlined
                    hide-selected
                    fill-input
                    use-input
                    input-debounce="0"
                    :value="address.city.id"
                    @input="setCity"
                    option-value="id"
                    option-name="label"
                    :options="cityOptions"
                    :options-dense="true"
                    @filter="searchCity"
                    emit-value
                    map-options
                    behavior="menu"
                    :error-message="address.errors.get('city.name')"
                    :error="address.errors.has('city.name')"
                    label="Город">
                    <template v-slot:no-option>
                        <q-item>
                            <q-item-section class="text-grey">
                                No results
                            </q-item-section>
                        </q-item>
                    </template>
                    <template v-slot:selected>
                        {{ address.city.name }}
                    </template>
                </q-select>
                <q-select
                    clearable
                    square
                    outlined
                    hide-selected
                    fill-input
                    use-input
                    input-debounce="0"
                    :value="address.street.id ? address.street.id : address.street.name"
                    @input-value="setStreet"
                    @clear="setStreet('')"
                    option-value="id"
                    option-name="label"
                    :options="streetOptions"
                    :options-dense="true"
                    @filter="searchStreet"
                    emit-value
                    map-options
                    hide-dropdown-icon
                    behavior="menu"
                    :error-message="address.errors.get('street.name')"
                    :error="address.errors.has('street.name')"
                    label="Улица">
                </q-select>
                <div class="row">
                    <div class="col">
                        <q-select
                            clearable
                            square
                            outlined
                            hide-selected
                            fill-input
                            use-input
                            input-debounce="0"
                            :value="address.house"
                            @input-value="setHouse"
                            @clear="setHouse('')"
                            option-value="id"
                            option-name="label"
                            :options="houseOptions"
                            :options-dense="true"
                            @filter="searchHouse"
                            emit-value
                            map-options
                            hide-dropdown-icon
                            behavior="menu"
                            :error-message="address.errors.get('house')"
                            :error="address.errors.has('house')"
                            label="Дом">
                        </q-select>
                    </div>
                    <div class="col pr-4 pl-4">
                        <q-input
                            square
                            outlined
                            :value="address.flat"
                            @input="setLocationFormValue('flat', $event)"
                            :error-message="address.errors.get('flat')"
                            :error="address.errors.has('flat')"
                            label="Квартира"/>
                    </div>
                    <div class="col">
                        <q-input
                            square
                            outlined
                            :value="address.zip"
                            @input="setLocationFormValue('zip', $event)"
                            :error-message="address.errors.get('zip')"
                            :error="address.errors.has('zip')"
                            label="Индекс" />
                    </div>
                </div>

                <q-card-actions class="q-pa-none">
                    <q-btn outline @click="modal = false" label="Отменить"></q-btn>
                    <q-btn color="primary" @click="submit">{{ id ? 'Обновить' : 'Добавить' }}</q-btn>
                </q-card-actions>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
    import location from './../../mixins/location';
    import { mapState, mapMutations, mapActions } from 'vuex';

    export default {
        name: 'CustomerAddress',
        props: {
            id: {
                type: Number,
                required: false,
                default: 0,
            }
        },
        mixins: [
            location,
        ],
        data: function () {
            return {
                //
            }
        },
        mounted: function () {
            //
        },
        watch: {
            modal (newValue, oldValue) {
                let _this = this;

                if (newValue) {
                    _this.useRegion = false;

                    if (!_this.id) {
                        _this.$store.dispatch('customer/newAddress');

                        _this.$nextTick(function () {
                            _this.initLocationOptions();
                        });
                    } else {
                        _this.formInitialization();

                        _this.$store.dispatch('customer/editAddress', _this.id);

                        _this.$nextTick(function () {
                            // _this.formInitialized();

                            _this.initLocationOptions();
                        });
                    }
                } else {
                    _this.$store.commit('customer/clearAddress');
                }
            }
        },
        methods: {
            ...mapMutations('customer', [
                'setAddressFormValue',
            ]),

            ...mapActions('customer', [
                'addAddress',
                'updateAddress',
            ]),

            getLocationForm () {
                return this.address;
            },

            setLocationFormValue (key, value) {
                this.setAddressFormValue({
                    key: key,
                    value: value
                });
            },

            submit () {
                if (this.id) {
                    // this.update();
                    this.updateAddress();
                } else {
                    // this.add();
                    this.addAddress();
                }
            },
        },
        computed: {
            ...mapState('customer', [
                'address',
            ]),

            modal: {
                get () {
                    return this.$store.state.customer.addressModal === this.id;
                },

                set (value) {
                    this.$store.commit('customer/hideAddressForm');
                }
            },

            storeUrl () {
                return this.id ? '/account/addresses' : '/addresses';
            },
        }
    }
</script>
